import React from 'react';
import PropTypes from 'prop-types';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt';

import Item from '../../../../models/Item';
import DetailLineItems from './DetailLineItems';
import Gallery from './Gallery';
import Button from '../../../common/Button';
import formPropsType from '../../../common/types/formPropsType';
import { convertType } from '../../../../config/constants';
import DisplayItems from '../../../../config/displayItems';
import './Header.css';

const Header = ({
  item, onDelete, saveButton, formProps, startInEditMode,
}) => {
  const onDeleteItem = () => {
    const {
      id,
      itemData: { title },
    } = item;

    if (
      // eslint-disable-next-line no-alert, no-restricted-globals
      confirm(`Are you sure you want to delete the entry for your ${title}?`)
    ) {
      onDelete(id);
    }
  };

  const onChangeMainAttachment = (newMainImage) => {
    const atts = item.attachments.map((att) => {
      return Object.assign({}, att, {
        isMainAttachement: att.id === newMainImage.id,
      });
    });

    formProps.setFieldValue('attachments', atts);
    formProps.handleSubmit();
  };

  const onDeleteImage = (image) => {
    if (image.isStock) {
      item.showStockImage = false;
      formProps.setFieldValue('attachments', item.attachments);
      formProps.handleSubmit();
    } else {
      const atts = item.attachments.filter((att) => {
        return att.id !== image.id;
      });

      formProps.setFieldValue('attachments', atts);
      formProps.handleSubmit();
    }
  };

  const uploadCallback = (results) => {
    formProps.setFieldValue('attachments', [...item.attachments, ...results]);
    formProps.handleSubmit();
  };

  return (
    <div className="itemHeader">
      <div className="itemHeader-gallery">
        <Gallery
          formProps={formProps}
          images={item.getImages()}
          onChangeMainAttachment={onChangeMainAttachment}
          onDeleteImage={onDeleteImage}
          onUploadNewAttachment={uploadCallback}
          allowUploads={!startInEditMode}
        />
      </div>

      <div className="itemHeader-info">
        <h3 className="title">{item.itemData.title}</h3>

        <dl>
          <DetailLineItems
            item={item}
            properties={DisplayItems.details[convertType(item.category)]}
            formProps={formProps}
            startInEditMode={startInEditMode}
          />
        </dl>
      </div>

      <div className="itemHeader-modifyActions">
        {onDelete && (
          <Button
            label={
              <FontAwesomeIcon
                icon={faTrashAlt}
                color="#ffffff"
                className="icon"
              />
            }
            color="danger"
            handler={onDeleteItem}
          />
        )}
        {saveButton}
      </div>
    </div>
  );
};

Header.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  onDelete: PropTypes.func,
  saveButton: PropTypes.node,
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
};

Header.defaultProps = {
  saveButton: null,
  onDelete: null,
  startInEditMode: false,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Header.jsx